<template>
  <div class="develop-progress">
    <div data-test="develop-review-scores" class="review-scores">
      <div
        v-for="(score, index) in scores"
        :key="score.name"
        class="review-score"
        :class="{ completed: !!score.scoreOutOf60 }"
        :data-test="`develop-score-${index}`"
      >
        <span class="review-score-name">{{ score.name }}</span>
        <PieChart :size="50" :percent="(100 * score.scoreOutOf60) / 60"></PieChart>
        <span class="review-score-number">{{ score.scoreOutOf60 || "?" }} / 60</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { DevelopProgressApiModel } from "../api-models";
import PieChart from "./pie-chart.vue";

export interface SelfReviewScore {
  name: string;
  scoreOutOf60: number | null | undefined;
}

const props = defineProps<{ model: DevelopProgressApiModel }>();

const scores = computed((): SelfReviewScore[] => {
  const { model } = props;
  return [
    {
      name: "Day 1",
      scoreOutOf60: model.currentStrengthProgress.week1Score,
    },
    {
      name: "Day 11",
      scoreOutOf60: model.currentStrengthProgress.week3Score,
    },
    {
      name: "Day 21",
      scoreOutOf60: model.currentStrengthProgress.week5Score,
    },

    // We no-longer show the follow-up score.
    //  { name: "Day 31", scoreOutOf60: model.currentStrengthProgress.followUpScore }
  ];
});
</script>

<style scoped lang="less">
.review-scores {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 10px;
}

.review-score {
  margin: 0 10px;
}

.review-score-name {
  white-space: nowrap;
  font-size: 12px;
}
</style>
